export default function SectionLabel({ children, ...props }) {
  return (
    <div className="inline-flex items-center gap-2.5" {...props}>
      <span className="accent-dot" />
      <span className="mono-label text-foreground/70">{children}</span>
    </div>
  );
}
